import dayjs from 'dayjs';
import { KsefExportJobStatus } from '../Types/ksefIncoming.types';

export type KsefStatusChipColor = 'success' | 'warning' | 'error' | 'default';

export const getKsefExportJobStatusColor = (
  status: KsefExportJobStatus | string
): KsefStatusChipColor => {
  switch (status) {
    case 'Completed':
      return 'success';
    case 'InProgress':
    case 'Initiated':
    case 'Truncated':
      return 'warning';
    case 'Failed':
      return 'error';
    default:
      return 'default';
  }
};

export const formatKsefDateTime = (value?: string | null): string => {
  if (!value) {
    return '—';
  }

  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('DD.MM.YYYY HH:mm') : '—';
};
